<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <rect width="17" height="9" x=".5" y=".5" :stroke="color" rx="1" />
      <path
        :fill="color"
        fill-rule="nonzero"
        d="M3.938 6.5l.714-1.964.72 1.964h.39l.93-2.515h-.4l-.725 2.033-.724-2.033h-.356l-.734 2.032-.71-2.032h-.425l.93 2.515h.39zm4.345 0l.714-1.964.72 1.964h.39l.93-2.515h-.4l-.725 2.033-.725-2.033h-.354l-.735 2.032-.71-2.032h-.425l.93 2.515h.39zm4.345 0l.714-1.964.72 1.964h.39l.93-2.515h-.4l-.725 2.033-.724-2.033h-.355l-.735 2.032-.71-2.032h-.426l.93 2.515h.39z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
